module.exports = __webpack_public_path__ + "static/media/motoamerica-dark@2x.a0a692bf.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/motoamerica-dark@2x.png
// module id = 386
// module chunks = 0